import React, { useState } from "react";
import DynamicTable from "../../global/Components/dynamicTable";
import { Container, Button, Grid, Card, Icon, Tooltip } from '@material-ui/core';
import CardHeader from '../../global/Components/cardHeader';
import Modal from '../../global/Components/modal';
import DetailProject from "./Components/detailProject";

function Projects() {

    const [reload, setReload] = useState(0);
    const [key, setKey] = useState(Math.random());
    const [modal, setModal] = useState({
        open: false,
        title: "",
        icon: "",
        color: "",
        component: "",
        size: "",
        key: Math.random(),
        height: "65vh"
    });

    //Definición de columnas
    const columns = [
        { accessor: "idProject", Header: "Id", width: "10%" },
        { accessor: "projectName", width: "30%", Header: "Nombre del proyecto" },
        { accessor: "projectCompany", width: "30%", Header: "Empresa" },
        { accessor: "projectManager", width: "20%", Header: "Contacto" },
        {
            Header: "Acciones", filterable: false, width: "10%", Cell: props =>
                <div>
                    <Tooltip title="Ver detalles">
                        <Button variant="outlined" onClick={() => { setModal({ open: true, title: "Configuración de proyecto", icon: "manage_accounts", color: "blue", size: "sm", component: <DetailProject setReload={() => setReload(Math.random())} idProject={props.row.original.idProject} />, key: Math.random() }) }}><Icon>more_horiz</Icon></Button>
                    </Tooltip>
                </div>
        }
    ];


    return (
        <Container className="projects req" maxWidth="xl">
            {/* ---------------- CABECERA -------------------- */}
            <Grid id="header" container spacing={5} padding={10}>
                <Grid item xs={12}><h2>Centros de trabajo</h2></Grid>
            </Grid>
            {/* ---------------- FIN CABECERA -------------------- */}
            <Button variant="outlined" className="elementInDynamicTableHeader"
                onClick={() => { setModal({ open: true, title: "Configuración de proyecto", icon: "manage_accounts", color: "blue", size: "sm", component: <DetailProject setReload={() => setReload(Math.random())} idProject="0" />, key: Math.random() }) }}
            >Nuevo proyecto</Button>
            <Card className="people-card dynamicTableHeaderAllowElements">
                <CardHeader title="Configuración de proyectos" icon="history" color="red" />
                <DynamicTable reload={reload} key={key} isOrdered={true} isGlobalSearch={true} columns={columns} endpoint={"Projects/All"} />
                <Modal key={modal.key} height={modal.height} open={modal.open} title={modal.title} icon={modal.icon} color={modal.color} component={modal.component} size={modal.size} />
            </Card>
        </Container>
    )
}

export default Projects;